import { render, staticRenderFns } from "./PointWithdrawLink.vue?vue&type=template&id=1d3572e1&scoped=true"
import script from "./PointWithdrawLink.vue?vue&type=script&lang=js"
export * from "./PointWithdrawLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3572e1",
  null
  
)

export default component.exports